@if (switchThemeService.currentTheme | async; as currentTheme) {
  <div>
    @if (config.enableSwitchTheme) {
      <patron-button
        shape="circle"
        variant="outline"
        [iconName]="currentTheme == 'light' ? 'bi-moon' : 'bi-sun'"
        [loading]="loadingTheme"
        (click)="switchThemeService.toggleTheme()">
      </patron-button>
    }
  </div>
}
